
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import { Getter } from '@/decorators';
import { AvatarSelectionOptions, UserDTO } from '@/models';
import { getUserDisplayInfo } from '@/services';
import UserInformation from '../user-information/UserInformation.vue';

@Component({
  components: {
    UserInformation
  }
})
export default class UserInput extends Vue {
  @Getter('user/users') usersStore: UserDTO[];
  @Prop({ default: () => [] }) listUser: UserDTO[];
  @VModel() userId: number;

  users: UserDTO[] = [];

  get userInfo(): UserDTO {
    const user = this.users.find(u => u.id == this.userId);
    return user || ({} as UserDTO);
  }

  get userOptions(): AvatarSelectionOptions {
    return this.users
      .filter(({ id, code }) => id && code)
      .map(({ avatarUrl, code, fullName, id }) => ({
        avatarUrl: avatarUrl,
        code: code,
        fullName: fullName,
        text: getUserDisplayInfo({ fullName, code } as UserDTO),
        value: id
      }));
  }

  mounted(): void {
    if (this.listUser && this.listUser.length > 0) {
      this.users = cloneDeep(this.listUser);
    } else {
      this.users = cloneDeep(this.usersStore);
    }
    this.$emit('change', this.userInfo);
  }

  @Watch('userId')
  onUserIdModelChanged(): void {
    this.$emit('change', this.userInfo);
  }
}
